<section class="ds-modal po-mapping-modal" aria-labelledby="po_mapping_modal_title">
    <div class="po-mapping-modal__header">
        <div class="ds-modal__header">
            <ds-text id="po_mapping_modal_title" size="xl" theme="primary" weight="medium">PO#</ds-text>
        </div>

        <ds-icon-button size="md" theme="secondary-gray" icon="close" (buttonClick)="onClose()"></ds-icon-button>
    </div>

    <form class="ds-modal__content ds-modal__content--scrollable po-mapping-modal__form" [formGroup]="poForm" novalidate>
        <ds-text *ngIf="isLoading" size="sm" text="Loading..."></ds-text>

        <ds-input
            *ngFor="let organ of organTypes.controls"
            class="po-mapping-modal__row"
            [formControl]="organ.controls.organTypeValue"
            [label]="organ.controls.organType.value"
            [placeholder]="'Add PO# for ' + organ.controls.organType.value"
        ></ds-input>
    </form>

    <div class="ds-modal__footer po-mapping-modal__footer">
        <ds-button label="Cancel" size="sm" theme="secondary-gray" (buttonClick)="onClose()"></ds-button>
        <ds-button label="Save Changes" size="sm" theme="primary" [isDisabled]="isLoading" (buttonClick)="onSave()"></ds-button>
    </div>
</section>
